// src/components/Footer.js
import logo from "../assets/layout/images/amie_logo_gray.png";

const Footer = () => {
  const curYear = new Date().getFullYear();

  return (
    <footer
      className="footer"
      style={{
        background: "#000000",
        color: "#BFBFBF",
        opacity: 1,
        padding: "28px 16px",
        textAlign: "center",
      }}
    >
      <img
        src={logo}
        alt="AMIESOFT"
        width="110"
        height="24"
        style={{ objectFit: "contain", marginBottom: 10, opacity: 0.95 }}
      />
      <div style={{ fontSize: 13 }}>
        ©{curYear} AMIESOFT Co., Ltd. All rights Reserved.
      </div>
    </footer>
  );
};

export default Footer;
